import { inject, Service } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { KidsBuchungKontaktComponent } from './kids-buchung-kontakt.component';
import { KidsBuchungImpressumComponent } from './kids-buchung-impressum.component';
import { KidsBuchungFaqComponent } from './kids-buchung-faq.component';
import { KidsTerminFristAbgelaufenComponent } from './kids-termin-frist-abgelaufen.component';

@Service()
export class KidsBuchungInfoService {
  readonly dialog = inject(MatDialog);

  kontaktInformation() {
    this.dialog.open(KidsBuchungKontaktComponent, {
      width: '600px'
    });
  }

  impressum() {
    this.dialog.open(KidsBuchungImpressumComponent, {});
  }

  faq() {
    this.dialog.open(KidsBuchungFaqComponent, {});
  }
  terminFristAbgelaufen(actionType: string) {
    this.dialog.open(KidsTerminFristAbgelaufenComponent, {
      data: {
        actionType
      }
    });
  }
}
